module.exports = __webpack_public_path__ + "img/556766.34fa60cc.png";